module.exports = __webpack_public_path__ + "static/media/slide-mobile (8).638702c7.jpg";